import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_POLYGON_OPACITY } from '@pn/services/styles';
import { generateMapConfig, setOriginalLayers } from '.';

export const units: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'units',
  dataType: 'units',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Units',
  description: '~3,000 units in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: generateMapConfig({
    itemId: 'units',
    type: LayerType.Polygon,
    style: {
      color: `hsla(90, 60%, 40%, ${DEFAULT_POLYGON_OPACITY})`,
    },
    source: {
      type: 'vector',
      minzoom: 6,
      maxzoom: 10,
      tiles: [
        isProduction()
          ? 'https://tiles.stackdx.com/units/{z}/{x}/{y}.pbf'
          : 'https://staging-tiles.stackdx.com/units/{z}/{x}/{y}.pbf',
      ],
    },
    sourceLayer: 'units',
    renderAsPoints: true,
  }),
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/units',
    requiredMapDataFields: ['internal_id', 'geometry'],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'agreement_id',
      'unit_name',
      'unit_termination_date',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'units',
    dataType: 'units',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
